import { gql } from '@apollo/client'

export const SAVE_DRAFT_POST = gql`
  mutation SaveDraftPost($input: SaveDraftPostInput!) {
    saveDraftPost(input: $input) {
      post {
        id
        text
        status
        editedAt
        editable
        linkUrl
        linkTitle
        photos {
          id
          url
        }
      }
      errors
    }
  }
`
